<template>
  <div>
    <LandingLayout>
      <LandingSectionWrapper
        v-for="(section,idx) in sections"
        :key="idx"
        v-bind="section"
      >
        <LandingSection
          v-bind="section"
        >
          <template v-if="section.hasSlot">
            <UnlockCourseForm
              v-if="!isCourseUnlocked"
              @submit="(args) => handleOnFormSubmit(section,args)"
            />
            <TButton
              v-else
              variant="orange"
              @click="() => handleOnAccessCourseClick(section)"
            >
              Access the course
            </TButton>
          </template>
        </LandingSection>
      </LandingSectionWrapper>
    </LandingLayout>
  </div>
</template>

<script>
import LandingSectionWrapper from '@/components/landing/LandingSectionWrapper.vue';
import LandingSection from '@/components/sections/LandingSection.vue';
import UnlockCourseForm from '@/components/forms/UnlockCourseForm.vue';
import LandingLayout from '@/components/landing/LandingLayout.vue';
import TButton from '@/components/base/TButton/TButton.vue';
import * as coursePromotionApi from '@/api/course-promotion';
import userMessages from '@/mixins/user-messages';

const COURSE_UNLOCKED_KEY = 'courseUnlocked';

export default {
  name: 'CoursePromotionPage',
  mixins: [userMessages],
  components: {
    TButton,
    LandingLayout,
    UnlockCourseForm,
    LandingSection,
    LandingSectionWrapper,
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isCourseUnlocked() {
      return !!localStorage.getItem(COURSE_UNLOCKED_KEY);
    },
  },
  methods: {
    async handleOnAccessCourseClick(section) {
      await this.$router.push({ name: section.pageToRedirect });
    },
    async handleOnFormSubmit(section, args) {
      try {
        const payload = {
          email: args.email,
          courseName: this.$route.name,
        };

        await coursePromotionApi.create(payload);
        await this.$router.push({ name: section.pageToRedirect });
        localStorage.setItem(COURSE_UNLOCKED_KEY, 'true');
      } catch (e) {
        this.setErrorMessage(e);
      } finally {
        args.cb();
      }
    },
  },
};
</script>
